import React from 'react';
import { Badge, Box, Group } from '@mantine/core';
import type { EntityRegistryEntry } from '../types';
import { getFileWarnings } from '../../validation/fileValidation';

export const fileConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'ContentType', 'FileName', 'Tags'],
    listColumns: () => [
        {
            key: 'contenttype',
            label: 'Content Type',
            sortable: true,
            render: (entity: any) => {
                const ct = (entity.ContentType || '').toString().trim();
                if (!ct) return '';
                const isImage = ct.startsWith('image/');
                const isText = ct.startsWith('text/');
                const color = isImage ? 'blue' : isText ? 'yellow' : 'gray';
                return <Badge variant="outline" size="sm" color={color}>{ct}</Badge>;
            }
        },
        {
            key: 'filename',
            label: 'File Name',
            sortable: true,
            render: (entity: any) => {
                const name = (entity.FileName || entity.Filename || '').toString().trim();
                if (!name) return '';
                return name.length > 40 ? `${name.slice(0, 37)}...` : name;
            }
        },
        {
            key: 'tags',
            label: 'Tags',
            sortable: false,
            render: (entity: any) => {
                let tags = entity.Tags || entity.tags;
                if (typeof tags === 'string' && tags.trim().startsWith('[')) {
                    try { tags = JSON.parse(tags); } catch { tags = tags ? [tags] : []; }
                }
                if (Array.isArray(tags) && tags.length > 0) {
                    return (
                        <Group gap={4} wrap="wrap">
                            {tags.map((tag: any, index: number) => (
                                <Badge key={index} variant="outline" size="sm">
                                    {typeof tag === 'string' ? tag : (tag.DisplayName || tag.displayName || String(tag))}
                                </Badge>
                            ))}
                        </Group>
                    );
                }
                return '';
            }
        }
    ],
    getWarnings: (data) => getFileWarnings(data),
};
